module.exports = __webpack_public_path__ + "img/doc-form.cfc5bd18.png";